"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GTS_QUESTION_GROUPS = void 0;
/* eslint-disable sonarjs/no-duplicate-string */
const Questions = require("../../questions/questions");
const answer_1 = require("../../utils/answer");
const group_1 = require("../../utils/group");
const question_1 = require("../../utils/question");
const { Question } = Questions;
const PARTNER_NOT_PART_OF_APPLICATION_FAMILY_INFORMATION = [
    Question["Other partner (spouse or common-law)"].label("HEAD_1"),
    Question["Do you have a partner (spouse or common-law) who is not part of this application?"]
        .label("FM_1")
        .ifAnswerEquals(answer_1.answer.yes)
        .renderTheseQuestions([
        Question["Full name"].label("FM_3"),
        Question["Date of Birth"].label("FM_5"),
        Question["Country of Birth"].label("FM_6"),
        Question["Is your partner (spouse or common-law) still living?"]
            .label("FM_2")
            .ifAnswerEquals(answer_1.answer.yes)
            .renderTheseQuestions([
            Question["Marital status"].label("FM_4"),
            Question["Current full address"].label("FM_7"),
            Question["Present occupation"].label("FM_8"),
        ])
            .ifAnswerEquals(answer_1.answer.no)
            .renderTheseQuestions([
            Question["In which city was your partner living when they passed?"].label("FM_9"),
            Question["In which country was your partner living when they passed?"].label("FM_10"),
            Question["On what date did your partner pass?"].label("FM_11"),
        ]),
    ]),
];
const PARENTS_CHILDREN_FAMILY_INFORMATION = [
    Question["Information about your Mother"].label("HEAD_2"),
    Question["Full name"].label("FM_13"),
    Question["Date of Birth"].label("FM_15"),
    Question["Country of Birth"].label("FM_16"),
    Question["Is your mother still living?"]
        .label("FM_12")
        .ifAnswerEquals(answer_1.answer.yes)
        .renderTheseQuestions([
        Question["Marital status"].label("FM_14"),
        Question["Current full address"].label("FM_17"),
        Question["Present occupation"].label("FM_18"),
    ])
        .ifAnswerEquals(answer_1.answer.no)
        .renderTheseQuestions([
        Question["In which city was your mother living when they passed?"].label("FM_19"),
        Question["In which country was your mother living when they passed?"].label("FM_20"),
        Question["On what date did your mother pass?"].label("FM_21"),
    ]),
    // Father
    Question["Information about your Father"].label("HEAD_3"),
    Question["Full name"].label("FM_23"),
    Question["Date of Birth"].label("FM_25"),
    Question["Country of Birth"].label("FM_26"),
    Question["Is your father still living?"]
        .label("FM_22")
        .ifAnswerEquals(answer_1.answer.yes)
        .renderTheseQuestions([
        Question["Marital status"].label("FM_24"),
        Question["Current full address"].label("FM_27"),
        Question["Present occupation"].label("FM_28"),
    ])
        .ifAnswerEquals(answer_1.answer.no)
        .renderTheseQuestions([
        Question["In which city was your father living when they passed?"].label("FM_29"),
        Question["In which country was your father living when they passed?"].label("FM_30"),
        Question["On what date did your father pass?"].label("FM_31"),
    ]),
    Question["Additional parents"].label("HEAD_4"),
    Question["Do you have any additional parents to list?"]
        .label("FM_32")
        .ifAnswerEquals(answer_1.answer.yes)
        .renderTheseQuestions([
        // Other parent
        Question["Full name"].label("FM_34"),
        Question["Date of Birth"].label("FM_36"),
        Question["Country of Birth"].label("FM_37"),
        Question["Are they still living?"]
            .label("FM_33")
            .ifAnswerEquals(answer_1.answer.yes)
            .renderTheseQuestions([
            Question["Marital status"].label("FM_35"),
            Question["Current full address"].label("FM_38"),
            Question["Present occupation"].label("FM_39"),
        ])
            .ifAnswerEquals(answer_1.answer.no)
            .renderTheseQuestions([
            Question["In which city were they living in when they passed?"].label("FM_40"),
            Question["In which country where they living in when they passed?"].label("FM_41"),
            Question["On what date did they pass?"].label("FM_42"),
        ]),
    ]),
    Question["Information about your Children"].label("HEAD_5"),
    Question["Do you have any other children that are not being included in this application or not coming with you to Canada?"]
        .label("FM_43")
        .ifAnswerEquals(answer_1.answer.yes)
        .renderTheseQuestions([
        Question["Please add all of your children who are not part of this application"].label("CUS_2"),
    ]),
];
exports.GTS_QUESTION_GROUPS = [
    (0, group_1.group)({
        uniqueKey: "TALENT_PERSONAL_DETAILS",
        id: 16,
        title: "Personal Details",
        subtitle: undefined,
        content: [
            Question["Have you ever used any other name?"]
                .label("PD_3")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Other first name(s)"].label("PD_4"),
                Question["Other last name(s)"].label("PD_5"),
            ]),
            Question["Sex"].label("PD_6"),
            Question["Date of Birth"].label("PD_7"),
            Question["City/Town (Place of birth)"].label("PD_8"),
            Question["Country or Territory (Place of birth)"].label("PD_9"),
            Question["Country of Citizenship"].label("PD_10"),
            Question["Do you have a second Country of Citizenship?"]
                .label("PD_12")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Secondary Country of Citizenship"].label("PD_13"),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "TALENT_CURRENT_COUNTRY_RESIDENCE",
        id: 18,
        title: "Current Country of Residence",
        subtitle: undefined,
        content: [
            Question["Current country of residence"].label("CR_1"),
            Question["Current country of residence status"]
                .label("CR_2")
                .ifAnswerEquals(answer_1.answer.other)
                .renderTheseQuestions([
                Question["Current country of residence other status"].label("CR_3"),
            ]),
            Question["Current country of residence from date"].label("CR_4"),
            Question["Current country of residence to date"].label("CR_5"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "TALENT_PREVIOUS_COUNTRY_RESIDENCE",
        id: 19,
        title: "Previous Country of Residence",
        subtitle: undefined,
        content: [
            Question["During the past five years have you lived in any country or territory other than your country of citizenship or your current country or territory of residence for more than six months?"]
                .label("CR_6")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Please add your previous countries of residence"].label("CUS_4"),
            ]),
            Question["Is your country or territory where you are applying the same as your current country or territory of residence?"]
                .label("CR_12")
                .ifAnswerEquals(answer_1.answer.no)
                .renderTheseQuestions([
                Question["Other country or territory"].label("CR_13"),
                Question["Other country status"]
                    .label("CR_14")
                    .ifAnswerEquals(answer_1.answer.other)
                    .renderTheseQuestions([
                    Question["Other country other status"].label("CR_15"),
                ]),
                Question["Other country from date"].label("CR_16"),
                Question["Other country to date"].label("CR_17"),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "TALENT_MARITAL_STATUS",
        id: 20,
        title: "Marital Status",
        subtitle: undefined,
        content: [
            Question["Your current marital status"].label("MR_1"),
            Question["If you are married or in a common-law relationship, please provide the date on which you were married on entered into common-law relationship"].label("MR_2"),
            Question["Have you previously been married or in a common-law relationship?"]
                .label("MR_3")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Previous spouse or common-law family name"].label("MR_4"),
                Question["Previous spouse or common-law given name(s)"].label("MR_5"),
                Question["Previous spouse or common-law date of birth"].label("MR_6"),
                Question["Previous spouse or common-law type of relationship"].label("MR_7"),
                Question["Previous spouse or common-law from date"].label("MR_8"),
                Question["Previous spouse or common-law to date"].label("MR_9"),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "TALENT_LANGUAGES",
        id: 21,
        title: "Languages",
        subtitle: undefined,
        content: [
            Question["Native language or Mother Tongue"].label("LNG_1"),
            Question["Are you able to communication in English and/or French?"].label("LNG_2"),
            Question["In which language are you most at ease?"].label("LNG_3"),
            Question["Have you taken a test from a designated testing agency to assess your proficiency in English or French?"].label("LNG_4"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "TALENT_PASSPORT",
        id: 22,
        title: "Passport Information",
        subtitle: undefined,
        content: [
            Question["Passport number"].label("ID_1"),
            Question["Country or territory of issue"].label("ID_2"),
            Question["Issue date"].label("ID_3"),
            Question["Expiry date"].label("ID_4"),
            Question["For this trip, will you use a passport issued by the Ministry of Foreign Affairs in Taiwan that includes your personal identification number?"].label("ID_5"),
            Question["For this trip, will you use a National Israeli Passport"].label("ID_6"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "TALENT_NATIONAL_IDENTITY",
        id: 23,
        title: "National Idenity Document",
        subtitle: undefined,
        content: [
            Question["Do you have a national identity document (NID)"]
                .label("ID_7")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["NID Document number"].label("ID_8"),
                Question["NID Country or territory of issue"].label("ID_9"),
                Question["NID Issue date"].label("ID_10"),
                Question["NID Expiry date"].label("ID_11"),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "TALENT_US_PR",
        id: 24,
        title: "US Permanent Resident (PR) Card Information",
        subtitle: undefined,
        content: [
            Question["Are you a lawful Permanent Resident of the United States with a valid alien registration card (green card)?"]
                .label("ID_12")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Green Card Document number"].label("ID_13"),
                Question["Green Card Expiry date"].label("ID_14"),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "TALENT_EDUCATION",
        id: 25,
        title: "Education Information",
        subtitle: undefined,
        content: [
            Question["Have you had any post secondary education (including university, college or apprenticeship training)?"]
                .label("EDU_1")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Field and level of Study"].label("EDU_2"),
                Question["School/Facility name"].label("EDU_3"),
                Question["City or Town"].label("EDU_4"),
                Question["Country or Territory"].label("EDU_5"),
                Question["Province or State"].label("EDU_6"),
                Question["Start date"].label("EDU_7"),
                Question["End date"].label("EDU_8"),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "TALENT_EMPLOYMENT",
        id: 26,
        title: "Employment Information",
        subtitle: undefined,
        content: [
            Question["Please add your employment history and previous job information"].label("CUS_3"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "TALENT_BACKGROUND_INFORMATION",
        id: 27,
        title: "Background Information",
        subtitle: undefined,
        content: [
            Question["Within the past two years, have you or a family member ever had tuberculosis of the lungs or have been in close contact with a person with tuberculosis?"]
                .label("BI_1")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Please provide details and the name of the family members (if applicable)"].label("BI_2"),
            ]),
            Question["Do you have any physical or mental disorders that would require you social and/or health services, other than medication, during a stay in Canada?"]
                .label("BI_3")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Please provide more details"].label("BI_4"),
            ]),
            Question["Have you ever remained beyond the validity of your status, attended school without authorization or worked without authorization in Canada?"]
                .label("BI_5")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Please provide details"].label("BI_6"),
            ]),
            Question["Have you ever been refused a visa or permit, denied entry or ordered to leave Canada or any other country or territory?"]
                .label("BI_7")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Please provide details"].label("BI_8"),
            ]),
            Question["Have you previously applied to enter or remain in Canada?"]
                .label("BI_9")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Please provide details"].label("BI_10"),
            ]),
            Question["Have you ever commited, been arrested for, been charged with or convicted of any criminal offence in any country or territory?"]
                .label("BI_11")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Please provide details"].label("BI_12"),
            ]),
            Question["Did you serve in any military, militia, or civil defence unit or serve in a security organization or police force (including non obligatory national service, reserve or volunteer units)?"]
                .label("BI_13")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Please provide dates of service and countries or territories where you served"].label("BI_14"),
            ]),
            Question["Are you, or have you ever been a member or associated with any political party, or other group or organization which has engaged in or advocated violence as a means to achieving political or religious objectiv, or which has been assoicated with criminal activity at the time?"].label("BI_15"),
            Question["Have you ever witnessed or participated in ill treatment of prisoners or civilians, looting or desecration of religious buidlings?"].label("BI_16"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "COMPANY_INTAKE_PART1",
        id: 6,
        title: "General Company Information",
        subtitle: undefined,
        content: [
            Question["15-digit CRA Payroll Number"].label("CG_10"),
            Question["Date Business Started"].label("CG_12"),
            Question["Organization Type and Structure"].label("CG_13"),
            Question["How many employees are employed nationally under the CRA number listed above?"].label("CG_14"),
            Question["What is the annual gross revenue of the business (in $CAD)?"].label("CG_15"),
            Question["Does your business receive support through Employment and Social Development Canada’s work Sharing program?"]
                .label("CG_16")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Please provide more details"].label("CG_32"),
            ]),
            Question["What are 2 activities you are already doing or can commit to doing for the next 2 years as a company?"].label("CG_17"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "COMPANY_CREATE_TALENT_PART1",
        id: 5,
        title: "Information about the Talents job role",
        subtitle: undefined,
        content: [
            Question["What is their expected start date to begin working in Canada?"].label("TAL_15"),
            Question["Why are they needed in Canada and what will they be working on while in Canada (1-2 sentences MAX)"].label("TAL_2"),
            Question["Is this job offer for 30 or more hours per week?"]
                .label("TAL_5")
                .ifAnswerEquals(answer_1.answer.no)
                .renderTheseQuestions([
                Question["Please explain why this job offer is for less than 30 hours per week"].label("TAL_6"),
            ]),
            Question["How many hours will they work per day?"].label("TAL_7"),
            Question["Is there any overtime being offered?"]
                .label("TAL_8")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["What's the overtime rate (per hour)?"].label("TAL_9"),
            ]),
            Question["What is the wage or salary?"].label("TAL_10"),
            Question["Please select any benefits being offered:"].label("TAL_11"),
            Question["What other benefits are being offered"].label("TAL_12"),
            Question["How many vacations days per year will be offered?"].label("TAL_13"),
            Question["Vacation pay (as % of gross salary) if applicable"].label("TAL_14"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "COMPANY_ROLE_PART1",
        id: 2,
        title: "About the Role",
        subtitle: undefined,
        content: [
            Question["NOC code"].label("ROLE_1"),
            Question["Main duties of the job"].label("ROLE_2"),
            Question["Is the position part of a union?"].label("ROLE_3"),
            Question["Have you tried to recruit inside Canada for this role?"]
                .label("ROLE_9")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Please explain your efforts for trying to recruiting inside Canada in 1-2 sentences"].label("ROLE_10"),
            ]),
            Question["In the last 12 months, have you laid off any employees in this role?"]
                .label("ROLE_11")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["How many Canadian citizens or permanent residents?"].label("ROLE_12"),
                Question["How many foreign workers?"].label("ROLE_13"),
                Question["What was the reason for the layoff(s) (1-2 sentences)?"].label("ROLE_14"),
            ]),
            Question["Will hiring for this role cause any layoffs or reduction in work of current employees?"]
                .label("ROLE_15")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Please explain how hiring for this role will cause layoffs"].label("ROLE_16"),
            ]),
            Question["Do you currently have employees working in Canada in the same role and similar level of experience?"]
                .label("ROLE_17")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["For the employees inside Canada with the same office location, role and years of experience, what is the lowest salary that you're currently paying?"].label("ROLE_18"),
                Question["For the employees inside Canada with the same office location, role and years of experience, what is the highest salary that you’re currently paying?"].label("ROLE_19"),
            ]),
            Question["Business operating name where the job will take place"].label("ROLE_20"),
            Question["Describe the main business activities that occur in this location"].label("ROLE_21"),
            Question["Please include a link to the role/job description/job posting that lists the main duties and responsibilities"].label("ROLE_33"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "COMPANY_ROLE_PART2",
        id: 3,
        title: "Role requirements",
        subtitle: undefined,
        content: [
            Question["Language requirement for the job"]
                .label("ROLE_4")
                .ifAnswerEquals(answer_1.answer.otherExplain)
                .renderTheseQuestions([
                Question["Other language requirement"].label("ROLE_5"),
            ]),
            Question["Minimum education requirements for the job"]
                .label("ROLE_6")
                .ifAnswerEquals(answer_1.answer.otherExplain)
                .renderTheseQuestions([
                Question["Other minimum education requirement"].label("ROLE_7"),
            ]),
            Question["Minimum experience and skills required (include years of experience and/or occupation designations if required)"].label("ROLE_8"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "COMPANY_ROLE_PART3",
        title: "Business information",
        id: 4,
        subtitle: undefined,
        content: [
            Question["Is there a labour dispute at any of the work locations?"].label("ROLE_22"),
            Question["Will the employee(s) be working at your primary business address?"]
                .label("ROLE_32")
                .ifAnswerEquals(answer_1.answer.no)
                .renderTheseQuestions([
                Question["Work location Address"].label("ROLE_23"),
                Question["Work location City"].label("ROLE_24"),
                Question["Work location Province"].label("ROLE_25"),
                Question["Work location Postal Code"].label("ROLE_26"),
                Question["Are there other work locations the job will take place in?"]
                    .label("ROLE_27")
                    .ifAnswerEquals(answer_1.answer.yes)
                    .renderTheseQuestions([
                    Question["Other work location Address"].label("ROLE_28"),
                    Question["Other work location City"].label("ROLE_29"),
                    Question["Other work location Province"].label("ROLE_30"),
                    Question["Other work location Postal Code"].label("ROLE_31"),
                ]),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "COMPANY_CREATE_TALENT_EMPLOYEE",
        id: 1,
        title: "Company Create Talent for Employee",
        subtitle: undefined,
        content: [
            Question["First name(s)"].label("PD_1"),
            Question["Last name"].label("PD_2"),
            Question["Country of Citizenship"].label("PD_10"),
            Question["Current country of residence"].label("CR_1"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "TALENT_GETTING_STARTED_PART1",
        id: 12,
        title: "What is your name?",
        subtitle: "We’ll need your full legal name as it appears on your government issued ID.",
        content: [
            Question["First name(s)"].label("PD_1"),
            Question["Last name"].label("PD_2"),
            Question["Date of Birth"].label("PD_7"),
            Question["Sex"].label("PD_6"),
            Question["Have you ever used any other name?"]
                .label("PD_3")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Other first name(s)"].label("PD_4"),
                Question["Other last name(s)"].label("PD_5"),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "TALENT_GETTING_STARTED_PART2",
        id: 13,
        title: "What is your address?",
        subtitle: "Please provide your current address",
        content: [
            Question["Street number"].label("CI_3"),
            Question["Street name"].label("CI_4"),
            Question["Apt or Unit number"].label("CI_2"),
            Question["City or Town"].label("CI_5"),
            Question["Province or State"].label("CI_7"),
            Question["Country or Territory"].label("CI_6"),
            Question["Postal code or ZIP code"].label("CI_8"),
            Question["P.O. Box"].label("CI_1"),
            Question["District"].label("CI_9"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "TALENT_GETTING_STARTED_PART3",
        id: 14,
        title: "Your information about residence",
        subtitle: "We need this information for your work permit application.",
        content: [
            Question["Country of Citizenship"].label("PD_10"),
            Question["Current country of residence"].label("CR_1"),
            Question["Have you lived in your current country of residence for longer than 6 months?"]
                .label("GS_1")
                .ifAnswerEquals(answer_1.answer.no)
                .renderTheseQuestions([
                Question["Have you lived any other country for 6 months or longer (continuously) in the last 12 months?"]
                    .label("GS_2")
                    .ifAnswerEquals(answer_1.answer.yes)
                    .renderTheseQuestions([
                    Question["What country did you live in, in the last 12 months (for 6 months or longer)?"].label("GS_3"),
                ]),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "TALENT_GETTING_STARTED_PART4",
        id: 15,
        title: "Family information",
        subtitle: "Tell us a bit about your family and who you will be bringing",
        content: [
            Question["Are you bringing any family members (spouse, common-law partner, children) with you to Canada?"]
                .label("PD_11")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["If you are bringing a spouse, common law partner and/or children with you to Canada, please add each of them here!"].label("CUS_1"),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "COMPANY_GETTING_STARTED_PART1",
        id: 8,
        title: "Please tell us about your business!",
        subtitle: "We need some general information about your business that is required in order to prepare and submit your LMIA application",
        content: [
            Question["Legal Business Name"].label("CG_1"),
            Question["Business Phone Number"].label("CG_2"),
            Question["Website URL"].label("CG_11"),
            Question["Have you been approved for a GTS (Global Talent Stream) application in the last 2 years?"].label("CG_9"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "COMPANY_GETTING_STARTED_PART2",
        id: 9,
        title: "Where is your business located in Canada?",
        subtitle: "We need the full address of your business.",
        content: [
            Question["Street number"].label("CC_2"),
            Question["Street name"].label("CC_3"),
            Question["Apt or Unit number"].label("CC_1"),
            Question["City or Town"].label("CC_4"),
            Question["Province"].label("CC_6"),
            Question["Country or Territory"].label("CC_5"),
            Question["Postal code or ZIP code"].label("CC_7"),
            Question["Is your mailing address different from your business address?"]
                .label("CC_8")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Street number (Mailing Address)"].label("CC_10"),
                Question["Street name (Mailing Address)"].label("CC_11"),
                Question["Apt or Unit number (Mailing Address)"].label("CC_9"),
                Question["City or Town (Mailing Address)"].label("CC_12"),
                Question["Province or State (Mailing Address)"].label("CC_14"),
                Question["Postal code or ZIP code (Mailing Address)"].label("CC_15"),
                Question["Country or Territory (Mailing Address)"].label("CC_13"),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "COMPANY_GETTING_STARTED_PART3",
        id: 10,
        title: "Primary Person Authorized to Instruct",
        subtitle: "The primary person of contact is someone who is involved in the recruitment process and is allowed to sign agreements on behalf of the company. In this case, signing a retainer agreement and/or immigration application. In most cases, this could be someone such as Head of People/Talent, Head of HR, VP Engineering, CTO, CEO, etc.\nIf you answer “No” to the first question, please provide the information for someone who can be the primary person of contact.",
        content: [
            Question["Do you want to be the primary person of contact and can you sign on behalf of the company?"]
                .label("CG_28")
                .ifAnswerEquals(answer_1.answer.no)
                .renderTheseQuestions([
                Question["First name(s)"].label("CG_19"),
                Question["Last name"].label("CG_20"),
                Question["Email address"].label("CG_22"),
            ]),
            Question["Job Title"].label("CG_18"),
            Question["Phone number"].label("CG_21"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "COMPANY_GETTING_STARTED_PART4",
        id: 7,
        title: "Information about yourself",
        subtitle: "We need this to set up your account.",
        content: [
            Question["First name(s)"].label("PD_1"),
            Question["Last name"].label("PD_2"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "COMPANY_GETTING_STARTED_PART5",
        id: 11,
        title: "Secondary Person Authorized to Instruct",
        subtitle: "The secondary person of contact is someone who is also allowed to sign agreements on behalf of the company, as the immigration application requires a second signature. This can be anyone at the company with signing authority (e.g. Head of Talent, Head of HR, CTO, CEO, CFO, etc).",
        content: [
            Question["First name(s)"].label("CG_24"),
            Question["Last name"].label("CG_25"),
            Question["Email address"].label("CG_27"),
            Question["Job Title"].label("CG_23"),
            Question["Phone number"].label("CG_26"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "TALENT_APPLICANT_CONTACT_INFORMATION",
        id: 17,
        title: "Contact Information",
        subtitle: undefined,
        content: [
            Question["Is your telephone number in Canada or USA?"].label("CI_19"),
            Question["Telephone number country code"].label("CI_21"),
            Question["Telephone number"].label("CI_22"),
            Question["Telephone number extension"].label("CI_23"),
            Question["Is your residential address the same as your mailing address?"]
                .label("CI_10")
                .ifAnswerEquals(answer_1.answer.no)
                .renderTheseQuestions([
                Question["Apt or Unit number (Residential Address)"].label("CI_11"),
                Question["Street number (Residential Address)"].label("CI_12"),
                Question["Street name (Residential Address)"].label("CI_13"),
                Question["City or Town (Residential Address)"].label("CI_14"),
                Question["Country or Territory (Residential Address)"].label("CI_15"),
                Question["Province or State (Residential Address)"].label("CI_16"),
                Question["Postal code or ZIP code (Residential Address)"].label("CI_17"),
                Question["District (Residential Address)"].label("CI_18"),
            ]),
            Question["Do you have an alternate telephone to add?"]
                .label("CI_24")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Is your alternate telephone number in Canada or USA?"].label("CI_25"),
                Question["Telephone number type (Alternate)"].label("CI_26"),
                Question["Telephone number country code (Alternate)"].label("CI_27"),
                Question["Telephone number (Alternate)"].label("CI_28"),
                Question["Telephone number extension (Alternate)"].label("CI_29"),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "TALENT_OTHER_CONTACT_INFORMATION",
        id: 30,
        title: "Contact Information",
        subtitle: undefined,
        content: [
            Question["Do you currently live with the main applicant in this application (the primary applicant who is being sponsored to come to Canada)?"]
                .label("CI_31")
                .ifAnswerEquals(answer_1.answer.no)
                .renderTheseQuestions([
                Question["P.O. Box"].label("CI_1"),
                Question["Apt or Unit number"].label("CI_2"),
                Question["Street number"].label("CI_3"),
                Question["Street name"].label("CI_4"),
                Question["City or Town"].label("CI_5"),
                Question["Country or Territory"].label("CI_6"),
                Question["Province or State"].label("CI_7"),
                Question["Postal code or ZIP code"].label("CI_8"),
                Question["District"].label("CI_9"),
            ]),
            Question["Is your residential address the same as your mailing address?"]
                .label("CI_10")
                .ifAnswerEquals(answer_1.answer.no)
                .renderTheseQuestions([
                Question["Apt or Unit number (Residential Address)"].label("CI_11"),
                Question["Street number (Residential Address)"].label("CI_12"),
                Question["Street name (Residential Address)"].label("CI_13"),
                Question["City or Town (Residential Address)"].label("CI_14"),
                Question["Country or Territory (Residential Address)"].label("CI_15"),
                Question["Province or State (Residential Address)"].label("CI_16"),
                Question["Postal code or ZIP code (Residential Address)"].label("CI_17"),
                Question["District (Residential Address)"].label("CI_18"),
            ]),
            Question["Is your telephone number in Canada or USA?"].label("CI_19"),
            Question["Telephone number country code"].label("CI_21"),
            Question["Telephone number"].label("CI_22"),
            Question["Telephone number extension"].label("CI_23"),
            Question["Do you have an alternate telephone to add?"]
                .label("CI_24")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Is your alternate telephone number in Canada or USA?"].label("CI_25"),
                Question["Telephone number type (Alternate)"].label("CI_26"),
                Question["Telephone number country code (Alternate)"].label("CI_27"),
                Question["Telephone number (Alternate)"].label("CI_28"),
                Question["Telephone number extension (Alternate)"].label("CI_29"),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "TALENT_CHILD_AND_TEEN_CONTACT_INFORMATION",
        id: 43,
        title: "Contact Information",
        subtitle: undefined,
        content: [
            Question["Do you currently live with the main applicant in this application (the primary applicant who is being sponsored to come to Canada)?"]
                .label("CI_31")
                .ifAnswerEquals(answer_1.answer.no)
                .renderTheseQuestions([
                Question["Street number"].label("CI_3"),
                Question["Apt or Unit number"].label("CI_2"),
                Question["Street name"].label("CI_4"),
                Question["City or Town"].label("CI_5"),
                Question["Country or Territory"].label("CI_6"),
                Question["Province or State"].label("CI_7"),
                Question["Postal code or ZIP code"].label("CI_8"),
                Question["District"].label("CI_9"),
                Question["P.O. Box"].label("CI_1"),
            ]),
            Question["Is your residential address the same as your mailing address?"]
                .label("CI_10")
                .ifAnswerEquals(answer_1.answer.no)
                .renderTheseQuestions([
                Question["Apt or Unit number (Residential Address)"].label("CI_11"),
                Question["Street number (Residential Address)"].label("CI_12"),
                Question["Street name (Residential Address)"].label("CI_13"),
                Question["City or Town (Residential Address)"].label("CI_14"),
                Question["Country or Territory (Residential Address)"].label("CI_15"),
                Question["Province or State (Residential Address)"].label("CI_16"),
                Question["Postal code or ZIP code (Residential Address)"].label("CI_17"),
                Question["District (Residential Address)"].label("CI_18"),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "TALENT_FAMILY_INFORMATION_APPLICANT",
        id: 28,
        title: "Family Information",
        subtitle: undefined,
        content: [
            (0, question_1.ifQuestionWithLabel)("PD_11")
                .answerEquals("No")
                .renderTheseQuestions(PARTNER_NOT_PART_OF_APPLICATION_FAMILY_INFORMATION),
            ...PARENTS_CHILDREN_FAMILY_INFORMATION,
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "TALENT_FAMILY_INFORMATION_CHILD_ADULT",
        id: 41,
        title: "Family Information",
        subtitle: undefined,
        content: [
            ...PARTNER_NOT_PART_OF_APPLICATION_FAMILY_INFORMATION,
            ...PARENTS_CHILDREN_FAMILY_INFORMATION,
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "TALENT_FAMILY_INFORMATION_PARTNER",
        id: 73,
        title: "Family Information",
        subtitle: undefined,
        content: PARENTS_CHILDREN_FAMILY_INFORMATION,
    }),
    (0, group_1.group)({
        uniqueKey: "TALENT_PROFILE_SUPPORTING_INFORMATION",
        id: 74,
        title: "Supporting Information",
        content: [
            Question["GitHub Profile URL"].label("TP_1"),
            Question["LinkedIn Profile URL"].label("TP_2"),
        ],
    }),
];
